exports.version = "2.2.8"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 563
// module chunks = 1